// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/sales_per_item_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { SalesPerItemItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.SalesPerItemReportRequest
 */
export class SalesPerItemReportRequest extends Message<SalesPerItemReportRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<SalesPerItemReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SalesPerItemReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SalesPerItemReportRequest {
    return new SalesPerItemReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SalesPerItemReportRequest {
    return new SalesPerItemReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SalesPerItemReportRequest {
    return new SalesPerItemReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SalesPerItemReportRequest | PlainMessage<SalesPerItemReportRequest> | undefined, b: SalesPerItemReportRequest | PlainMessage<SalesPerItemReportRequest> | undefined): boolean {
    return proto3.util.equals(SalesPerItemReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SalesPerItemReportResponse
 */
export class SalesPerItemReportResponse extends Message<SalesPerItemReportResponse> {
  /**
   * List of sales per item
   *
   * @generated from field: repeated com.neulink.pharmacy.SalesPerItemItem sales_per_item_items = 1;
   */
  salesPerItemItems: SalesPerItemItem[] = [];

  /**
   * Total number of items available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<SalesPerItemReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SalesPerItemReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sales_per_item_items", kind: "message", T: SalesPerItemItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SalesPerItemReportResponse {
    return new SalesPerItemReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SalesPerItemReportResponse {
    return new SalesPerItemReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SalesPerItemReportResponse {
    return new SalesPerItemReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SalesPerItemReportResponse | PlainMessage<SalesPerItemReportResponse> | undefined, b: SalesPerItemReportResponse | PlainMessage<SalesPerItemReportResponse> | undefined): boolean {
    return proto3.util.equals(SalesPerItemReportResponse, a, b);
  }
}

